import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Reveal from '../../components/Reveal';
import usePageTitle from '../../hooks/usePageTitle';

function Accordion({ item, index }) {
  const [open, setOpen] = useState(false);
  return (
    <Reveal as="div" className={`accordion ${open ? 'is-open' : ''}`} delay={index * 50}>
      <button type="button" onClick={() => setOpen((v) => !v)} aria-expanded={open}>
        <span>{item.q}</span>
        <span className="accordion-icon" aria-hidden="true" />
      </button>
      <div className="accordion-panel" role="region">
        <p>{item.a}</p>
      </div>
    </Reveal>
  );
}

export default function Faq() {
  const { t } = useTranslation();
  usePageTitle(t('faq.pageTitle'));
  const groups = t('faq.groups', { returnObjects: true });

  return (
    <>
      <section className="page-hero">
        <div className="shell">
          <Reveal>
            <span className="eyebrow">{t('faq.eyebrow')}</span>
            <h1>{t('faq.title')}</h1>
            <p className="lede">{t('faq.lede')}</p>
          </Reveal>
        </div>
      </section>

      <section className="band">
        <div className="shell shell-narrow">
          {groups.map((group) => (
            <div className="faq-group" key={group.group}>
              <Reveal as="h2" className="faq-group-title">{group.group}</Reveal>
              {group.items.map((item, i) => (
                <Accordion key={item.q} item={item} index={i} />
              ))}
            </div>
          ))}

          <Reveal className="cta-band">
            <div>
              <h2>{t('faq.stillNotSure')}</h2>
              <p>{t('faq.stillNotSureBody')}</p>
            </div>
            <Link className="btn btn-primary" to="/contact">{t('faq.contactOffice')}</Link>
          </Reveal>
        </div>
      </section>
    </>
  );
}
